var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 300 120",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "lyOrange",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#D97D2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#F5A64A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lyTeal",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#1E4C5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#143742"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "lyShadow",
    x: "-10%",
    y: "-10%",
    width: "120%",
    height: "120%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 4,
    stdDeviation: 4,
    floodOpacity: 0.2
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(15, 20)",
    filter: "url(#lyShadow)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 40,
    r: 32,
    fill: "url(#lyOrange)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42,18 L26,42 L37,42 L32,62 L52,36 L39,36 Z",
    fill: "#FFFFFF"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(95, 68)"
  }, /*#__PURE__*/React.createElement("text", {
    fontFamily: "'Outfit', 'Inter', system-ui, sans-serif",
    fontWeight: 900,
    fontSize: 38,
    fill: "#1E4C5C",
    letterSpacing: -0.5
  }, "\n      LOGO ", /*#__PURE__*/React.createElement("tspan", {
    fill: "#D97D2B"
  }, "YA!")), /*#__PURE__*/React.createElement("text", {
    x: 2,
    y: 20,
    fontFamily: "'Inter', system-ui, sans-serif",
    fontWeight: 700,
    fontSize: 11,
    fill: "#1E4C5C",
    opacity: 0.8,
    letterSpacing: 1.8
  }, "\n      DESAF\xCDO R\xC1PIDO\n    "))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.72289ddd70a1eefc248fc00d1d878947.svg";
export { ForwardRef as ReactComponent };